import { db } from '@/firebase/init'
import { useUserStore } from '@/stores/userStore'
import { ReportDescriptionItem } from '@team-milva/lab-models/resources'
import { collection, onSnapshot, query, where } from 'firebase/firestore'
import { defineStore } from 'pinia'

// Read-only lab catalog data (Apps/-lab-management-/ReportDescriptionItems) —
// the items a multi-select-text/multi-select-number analysis test's result
// references by reportDescriptionItemID (see analysisResultDisplay.ts). This
// app never creates/edits report descriptions, so no write actions here,
// unlike lab-management's own store for the same resource.
export const useReportDescriptionItemStore = defineStore('reportDescriptionItem', {
  state: () => ({
    allReportDescriptionItems: [] as ReportDescriptionItem[],
    unsubscribeAllReportDescriptionItems: null as (() => void) | null,
  }),

  actions: {
    getReportDescriptionItems(): Promise<ReportDescriptionItem[]> {
      if (this.allReportDescriptionItemsLoaded) {
        return Promise.resolve(this.allReportDescriptionItems)
      }

      const userStore = useUserStore()

      return new Promise((resolve) => {
        if (!userStore.currentUser) {
          return resolve([])
        }

        let resolved = false
        const q = query(
          collection(db, 'Apps', '-lab-management-', 'ReportDescriptionItems'),
          where('labAccountID', '==', userStore.currentUser.labAccountID)
        )

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
          this.allReportDescriptionItems = querySnapshot.docs.map(
            (docSnap) => new ReportDescriptionItem(docSnap.data())
          )
          this.unsubscribeAllReportDescriptionItems = unsubscribe

          if (!resolved) {
            resolved = true
            resolve(this.allReportDescriptionItems)
          }
        })
      })
    },

    resetStore(): void {
      this.allReportDescriptionItems = []
      this.unsubscribeAllReportDescriptionItems?.()
      this.unsubscribeAllReportDescriptionItems = null
    },
  },

  getters: {
    allReportDescriptionItemsLoaded: (state) => !!state.unsubscribeAllReportDescriptionItems,
  },
})
